
<li
  :class="classes"
  v-show="!hidden"
  @click="triggerSelect(value)"
  :value="value"
>
  <slot>{{ showLabel }}</slot>
</li>
